import React from 'react';
import styled from 'styled-components';
import { IBaseSvgParams } from 'types';

export interface IPairDot extends IBaseSvgParams {
  isPlayerPair?: boolean;
  isBankerPair?: boolean;
}

const PairDotStyled = styled.svg``;

export const PairDot = ({
  isPlayerPair = false,
  isBankerPair = false,
  size = { height: 16, width: 16 },
  position = [0, 1],
}: IPairDot) => {
  const [positionX, positionY] = position;
  return (
    <PairDotStyled
      height={size.height}
      width={size.width}
      x={positionX}
      y={positionY}
      viewBox="0 0 16 16">
      <circle
        cx="2"
        cy="2"
        r="2"
        fill={isPlayerPair ? '#EA184A' : isBankerPair ? '#52B1DF' : 'transparent'}
        stroke="#000000"
        strokeWidth={1}
      />
    </PairDotStyled>
  );
};
